import React from "react";
import { motion } from "framer-motion";

export function EmptyState({ text }) {
    return (
        <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }}
            className="text-center py-8 px-4 bg-surface/50 rounded-2xl border border-dashed border-warm-300/40"
        >
            <p className="font-body text-sm text-warm-500">{text}</p>
        </motion.div>
    );
}

export default EmptyState;
